// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Parking_S1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0rem;
    gap: 2rem;
    flex-direction: column;
    width: 100%;
}

.Parking_S1_B1 {
    display: flex;
    gap: 1rem;
    width: 100%;
    padding: 1rem 1rem 3rem 1rem;
    flex-wrap: wrap;
    /* box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px; */
}

.Parking_S1_B1>div>select {
    margin-top: 1rem;
    font-size: 1rem;
    font-weight: 300;
    padding: 0rem;
    height: unset;
    border: none;
    border-bottom: 1px gray solid;
}

.Parking_S1_B1>div {
    width: max-content;
    min-width: 150px;
}

.Parking_S1_C2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;

}

.Parking_S1_C2>:nth-child(1) {
    display: flex;
    width: 55% !important;
    justify-content: center;
    align-items: center;
}

.Parking_S1_C2>:nth-child(2) {
    display: flex;
    flex-direction: row;
    gap: 2rem;
    justify-content: center;
    /* width: 20%; */
    flex-wrap: wrap;
}

.Parking_S2 {
    height: 50vw;
    width: 100%;
    margin: 0 auto;
    overflow: hidden
}

@media screen and (max-width: 1025px) {
    .Parking_S1_B1>div {
        width: 30%;
    }
}

@media screen and (max-width: 600px) {
    .Parking_S1_B1>div {
        width: 100%;
    }

    .Parking_S1_C2 {
        flex-direction: column;
    }

    .Parking_S1_C2>:nth-child(1) {
        width: 100%;
    }
    .Parking_S2 {
        height: 80vw;
        width: 100%;
        margin: 0 auto;
        overflow: hidden
    }
}

`, "",{"version":3,"sources":["webpack://./src/Pages/ProjectDetails/Parkings/Parking.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,4BAA4B;IAC5B,eAAe;IACf,uDAAuD;AAC3D;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,WAAW;QACX,cAAc;QACd;IACJ;AACJ","sourcesContent":[".Parking_S1 {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 0rem;\n    gap: 2rem;\n    flex-direction: column;\n    width: 100%;\n}\n\n.Parking_S1_B1 {\n    display: flex;\n    gap: 1rem;\n    width: 100%;\n    padding: 1rem 1rem 3rem 1rem;\n    flex-wrap: wrap;\n    /* box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px; */\n}\n\n.Parking_S1_B1>div>select {\n    margin-top: 1rem;\n    font-size: 1rem;\n    font-weight: 300;\n    padding: 0rem;\n    height: unset;\n    border: none;\n    border-bottom: 1px gray solid;\n}\n\n.Parking_S1_B1>div {\n    width: max-content;\n    min-width: 150px;\n}\n\n.Parking_S1_C2 {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 2rem;\n    width: 100%;\n    flex-direction: row;\n    flex-wrap: wrap;\n\n}\n\n.Parking_S1_C2>:nth-child(1) {\n    display: flex;\n    width: 55% !important;\n    justify-content: center;\n    align-items: center;\n}\n\n.Parking_S1_C2>:nth-child(2) {\n    display: flex;\n    flex-direction: row;\n    gap: 2rem;\n    justify-content: center;\n    /* width: 20%; */\n    flex-wrap: wrap;\n}\n\n.Parking_S2 {\n    height: 50vw;\n    width: 100%;\n    margin: 0 auto;\n    overflow: hidden\n}\n\n@media screen and (max-width: 1025px) {\n    .Parking_S1_B1>div {\n        width: 30%;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .Parking_S1_B1>div {\n        width: 100%;\n    }\n\n    .Parking_S1_C2 {\n        flex-direction: column;\n    }\n\n    .Parking_S1_C2>:nth-child(1) {\n        width: 100%;\n    }\n    .Parking_S2 {\n        height: 80vw;\n        width: 100%;\n        margin: 0 auto;\n        overflow: hidden\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
